import createManagementIntegrationStorage from "./factory";
import {
    managementIntegrationDynamicsStorageProvider,
    managementIntegrationHsStorageProvider,
    managementIntegrationSfStorageProvider,
    managementIntegrationSignalApiStorageProvider,
} from "./provider";

export const managementIntegrationHsStorage = createManagementIntegrationStorage(
    managementIntegrationHsStorageProvider,
);

export const managementIntegrationSfStorage = createManagementIntegrationStorage(
    managementIntegrationSfStorageProvider,
);

export const managementIntegrationDynamicsStorage = createManagementIntegrationStorage(
    managementIntegrationDynamicsStorageProvider,
);

export const managementIntegrationSignalApiStorage = createManagementIntegrationStorage(
    managementIntegrationSignalApiStorageProvider,
);
